<div class="slide-packages">
    <div class="slide-container">
        <img src="assets/img/dashboard-informations/slide4.png">
    </div>
</div>